import { Link, useLocation } from 'react-router';
import type { MultiLang } from '../../config';

interface Props {
    lang: MultiLang;
    className?: string;
}

const langResources = {
    en: 'English',
    ja: 'Japanese',
};

const LangLink = (props: Props) => {
    const { lang, className } = props;
    const location = useLocation();
    const params = new URLSearchParams(location.search);
    const flagLang = lang === 'en' ? 'ja' : 'en';
    params.set('ml_lang', flagLang);
    const url = `${location.pathname}?${params.toString()}`;
    return (
        <Link className={className} to={url}>
            <span>{langResources[flagLang]}</span>
        </Link>
    );
};

export default LangLink;
